import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';



@Component({
  selector: 'page-para-ustu-modal',
  templateUrl: 'para-ustu-modal.html',
})
export class ParaUstuModalPage {
siparistoplam:number=0;
alinanpara:number=0;
paraustu:number=0;
@ViewChild('inputs') inputs;
  constructor(public navCtrl: NavController,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("toplam") != null) {
        this.siparistoplam = navParams.get("toplam");
      }
  }

  ionViewDidLoad() {
    setTimeout(() => {
      this.inputs.setFocus();
    },500);

     this.alinanpara=0;

  }
  hazirtutarekle(sayi)
  {
    this.alinanpara=sayi;
  }
  kapat()
  {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/PerakendeIslemleri/para-ustu-modal/para-ustu-modal.ts